<template>
  <v-card id="historyVisits" tile>
    <v-card-title>
      <v-toolbar flat>
        <v-toolbar-title>{{ resx.labels.historyVisits }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          :label="resx.labels.search"
          single-line
          hide-details
          v-model="filters.search"
        >
        </v-text-field>
      </v-toolbar>
    </v-card-title>
    <v-card-text class="table-container fixed-header">
      <v-row>
        <v-col class="col-3">
          <datepicker-component
            :label="`Filtrar por ${resx.labels.dateStart}`"
            :left="true"
            @input="filters.dateFrom = $event"
            :value="filters.dateFrom"
          />
        </v-col>
        <v-col class="col-3">
          <datepicker-component
            :label="`Filtrar por ${resx.labels.dateEnd}`"
            :left="true"
            @input="filters.dateTo = $event"
            :value="filters.dateTo"
          />
        </v-col>
        <v-col
          class="col-4"
          v-if="
            $store.state.auth.user.roles[0] ==
              $store.state.constants.roles.SYS_ADMIN
          "
        >
          <v-select
            menu-props="left, offsetY"
            clearable
            :items="companies"
            :label="`Filtrar por ${resx.labels.company}`"
            item-text="name"
            item-value="_id"
            v-model="filters.company"
            name="company"
            :no-data-text="resx.messages.noSelectorDataAvailable"
            :disabled="loading"
          />
        </v-col>
        <v-col class="count-items">
          <v-col>
            <span v-if="history.length > 0">
              {{ `${resx.labels.countItems}: ${count}` }}
            </span>
          </v-col>
        </v-col>
      </v-row>
      <v-row>
        <v-col fill-height class="scrollable mt-2">
          <v-data-table
            :class="{ 'layout-fixed': $vuetify.breakpoint.lgAndUp }"
            :headers="headers"
            :items="history"
            :no-data-text="
              firstTimeLoading ? '' : resx.messages.noVisitsAvailable
            "
            :no-results-text="
              firstTimeLoading ? '' : resx.messages.noVisitsFound
            "
            :search="search"
            :sort-desc="true"
            :loading="loading"
            fixed-header
            sort-by="dateOfVisit"
            ref="dataTable"
            :items-per-page="itemsPerPage"
            :footer-props="{ itemsPerPageOptions: [15, 50, 100], itemsPerPageText: 'Mostrar' }"
            @update:items-per-page="saveItemsPerPage"
            loading-text=""
          >
            <template v-slot:loading>
              <BarLoader :isLoading="loading" />
            </template>
            <template v-slot:item.contractorCompany.contractor.name="{ item }">
              <td class="word-wrap">
                {{ item.contractorCompany.contractor.name }}
              </td>
            </template>
            <template v-slot:item.dateOfVisit="{ item }">
              <td>
                <a @click="openDetail(item)">{{
                  item.dateOfVisit | date("short")
                }}</a>
              </td>
            </template>
            <template v-slot:item.endOfVisit="{ item }">
              <td>
                <!-- <div class="success--text"
                  v-if="item.state == 'rated' && item.endOfVisit == null ||
                    item.state == 'active' && item.endOfVisit == null">
                  {{ resx.labels.visitInProgress }}
                </div> -->
                <a @click="openDetail(item)">
                  {{ item.endOfVisit | date("short") }}
                </a>
              </td>
            </template>
            <template v-slot:item.duration="{ item }">
              <td>{{ duration(item) }}</td>
            </template>
            <template v-slot:item.rate="{ item }">
              <td class="hidden-xs-only">
                <div v-if="item.state == 'rated' || item.state == 'finished' && item.rate != null">
                  <star-rating
                    :read-only="true"
                    :star-size="20"
                    :rating="item.rate"
                    :padding="8"
                    :show-rating="false"
                    :rounded-corners="true"
                    active-color="#4caf50"
                  ></star-rating>
                </div>
                <div class="error--text justify-center"
                  v-if="item.state == 'pending_authorization' && !item.closedAt">
                  {{ resx.labels.requestAccessPending }}</div>
                <div class="error--text justify-center"
                  v-if="item.state == 'authorized' && !item.closedAt">
                  {{ resx.labels.authorized }}</div>
                <div class="justify-center"
                  v-if="item.state == 'rejected' && item.closedAt">
                  {{ resx.labels.requestAccessRejected }}</div>
                <div class="justify-center"
                  v-if="item.state == 'cancelled' && item.closedAt">
                  {{ resx.labels.accessCancelled }}</div>
                <div class="success--text justify-center"
                  v-if="(item.state == 'active' || item.state == 'rated') && item.closedAt == null">
                  {{ resx.labels.visitInProgress }}</div>
                <div class="error--text justify-center"
                  v-if="(item.state == 'finished' && item.rate == null) || (item.state == 'pending_rate')">
                  {{ resx.labels.pendingScoreVisit }}</div>
              </td>
            </template>
            <!-- Visit in Progress -->
            <template v-slot:item.state="{ item }">
              <td class="hidden-xs-only">
                <div v-if="
                (item.state == 'active' && item.rate != null) ||
                (item.state == 'rated' && item.closedAt != null) || (item.state == 'finished' && item.rate != null)">
                  <star-rating
                    :read-only="true"
                    :star-size="20"
                    :rating="item.rate"
                    :padding="8"
                    :show-rating="false"
                    :rounded-corners="true"
                    active-color="#4caf50"
                  ></star-rating>
                </div>
                <span
                  class="error--text justify-center"
                  v-if="item && (item.state == 'finished' && item.rate == null) || (item.state == 'pending_rate')"
                  >{{ resx.labels.pendingScoreVisit }}</span
                >
                <span
                  class="error--text justify-center"
                  v-if="item && (item.state == 'active' && item.rate == null)"
                  >{{ resx.labels.pendingScoreVisit }}</span
                >
                <span class="error--text" v-else></span>
              </td>
            </template>
            <template v-slot:item.comments="{ item }">
              <td class="hidden-sm-and-down">
                <comments :readonly="true" :value="item.comment"></comments>
              </td>
            </template>
            <template v-slot:item.motive="{ item }">
              <td class="hidden-sm-and-down word-wrap">
                {{ item.motive }}
              </td>
            </template>
            <template v-slot:item.actions="{ item }">
              <td class="justify-center layout px-0">
                <v-menu bottom auto>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-if="
                        canRate &&
                          (item.state == 'active' ||
                            item.state == 'pending_rate') &&
                          (!item.closedAt || item.endOfVisit != null)
                      "
                      @click="rateVisit = item"
                    >
                      <v-list-item-action>
                        <v-icon color="primary">star</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        resx.labels.qualify
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      v-if="item.state == 'authorized'"
                      @click="cancel(item)"
                    >
                      <v-list-item-action>
                        <v-icon color="primary">cancel</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        resx.labels.cancel
                      }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openDetail(item)">
                      <v-list-item-action>
                        <v-icon color="primary">visibility</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>{{
                        resx.labels.view
                      }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row column fill-height id="historyVisits"> </v-row>
    </v-card-text>

    <!-- right side "modal" -->
    <v-navigation-drawer
      id="visitDetail"
      right
      fixed
      clipped
      temporary
      v-model="showDetail"
      :stateless="!showDetail || rateVisit != null"
      width="500"
      style="z-index:100"
    >
      <v-row>
        <v-col class="col-12">
          <v-app-bar dark flat color="primary">
            <v-app-bar-nav-icon @click="closeDetail()">
              <v-icon>arrow_back</v-icon>
            </v-app-bar-nav-icon>
            <v-toolbar-title dark>{{
              resx.labels.visitDetail.toUpperCase()
            }}</v-toolbar-title>
          </v-app-bar>
          <v-list two-line>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary">perm_contact_calendar</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>{{
                  resx.labels.contractor
                }}</v-list-item-subtitle>
                <v-list-item-title>{{
                  selectedVisit &&
                    selectedVisit.contractorCompany.contractor.name
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary">person</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>{{
                  resx.labels.authorizedAccess
                }}</v-list-item-subtitle>
                <v-list-item-title>{{
                  selectedVisit && selectedVisit.allowAccessBy.fullname
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary">event</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>{{
                  resx.labels.startDateTimeOfVisit
                }}</v-list-item-subtitle>
                <v-list-item-title
                  class="capitalize">{{
                  selectedVisit && selectedVisit.dateOfVisit | date("longDate")
                }}</v-list-item-title>
                <v-list-item-title
                  class="capitalize">{{
                  selectedVisit && selectedVisit.dateOfVisit | date("shortTime")
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary">event</v-icon>
              </v-list-item-action>
              <v-list-item-content v-if="selectedVisit && selectedVisit.endOfVisit != null">
                <v-list-item-subtitle>{{
                  resx.labels.endDateTimeOfVisit
                }}</v-list-item-subtitle>
                <v-list-item-title class="capitalize">{{
                  selectedVisit && selectedVisit.endOfVisit | date("longDate")
                }}</v-list-item-title>
                <v-list-item-title class="capitalize">{{
                  selectedVisit && selectedVisit.endOfVisit | date("shortTime")
                }}</v-list-item-title>
              </v-list-item-content>
              <div v-else>
                <v-list-item-subtitle>{{
                  resx.labels.endDateTimeOfVisit
                }}</v-list-item-subtitle>
                <v-list-item-title>
                <div class="error--text justify-center"
                  v-if="selectedVisit && selectedVisit.state == 'pending_authorization' && !selectedVisit.closedAt">
                  {{ resx.labels.requestAccessPending }}</div>
                <div class="error--text justify-center"
                  v-if="selectedVisit && selectedVisit.state == 'authorized' && !selectedVisit.closedAt">
                  {{ resx.labels.authorized }}</div>
                <div class="success--text justify-center"
                  v-if="selectedVisit && (selectedVisit.state == 'active' || selectedVisit.state == 'rated')">
                  {{ resx.labels.visitInProgress }}</div>
                </v-list-item-title>
              </div>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary">hourglass_full</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>{{
                  resx.labels.duration
                }}</v-list-item-subtitle>
                <v-list-item-title
                  v-if="
                    selectedVisit &&
                      selectedVisit.dateOfVisit
                  "
                  >{{ duration(selectedVisit) }}</v-list-item-title
                >
                <v-list-item-title v-else>{{
                  resx.messages.noDataAvailable
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="
                selectedVisit &&
                  (selectedVisit.state == 'finished' ||
                    selectedVisit.state == 'active' ||
                    selectedVisit.state == 'pending_rate' ||
                    selectedVisit.state == 'rated')
              "
            >
              <v-list-item-action>
                <v-icon color="primary">star</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>{{
                  resx.labels.qualification
                }}</v-list-item-subtitle>
                <star-rating
                  v-if="selectedVisit && selectedVisit.rate != null"
                  :read-only="true"
                  :star-size="20"
                  :rating="selectedVisit.rate"
                  :padding="8"
                  :show-rating="false"
                  :rounded-corners="true"
                  active-color="#4caf50"
                ></star-rating>
                <v-list-item-title
                  class="error--text"
                  v-if="selectedVisit && selectedVisit.rate == null">{{
                    resx.labels.pendingScoreVisit
                }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action
                v-if="canRate && selectedVisit && selectedVisit.rate == null"
              >
                <v-btn @click="rateVisit = selectedVisit" color="primary">{{
                  resx.labels.qualify
                }}</v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              v-if="selectedVisit && selectedVisit.rate != null"
            >
              <v-list-item-action>
                <v-icon color="primary">event</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>{{
                  resx.labels.qualifiedAt
                }}</v-list-item-subtitle>
                <v-list-item-title class="capitalize">{{
                  selectedVisit && selectedVisit.ratedAt | date("longDate")
                }}</v-list-item-title>
                <v-list-item-title class="capitalize">{{
                  selectedVisit && selectedVisit.ratedAt | date("shortTime")
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="selectedVisit && selectedVisit.ratedBy">
              <v-list-item-action>
                <v-icon color="primary">person</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>{{
                  resx.labels.qualifiedBy
                }}</v-list-item-subtitle>
                <v-list-item-title>{{
                  selectedVisit && selectedVisit.ratedBy.fullname
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary">subject</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>{{
                  resx.labels.visitMotive
                }}</v-list-item-subtitle>
                <v-list-item-title
                  v-if="selectedVisit && selectedVisit.motive"
                  >{{
                    selectedVisit && selectedVisit.motive
                  }}</v-list-item-title
                >
                <v-list-item-title v-else>{{
                  resx.messages.noDataAvailable
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-action>
                <v-icon color="primary">subject</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-subtitle>{{
                  resx.labels.comments
                }}</v-list-item-subtitle>
                <v-list-item-title
                  v-if="selectedVisit && selectedVisit.motive"
                  >{{
                    selectedVisit && selectedVisit.comment
                  }}</v-list-item-title
                >
                <v-list-item-title v-else>{{
                  resx.messages.noDataAvailable
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-navigation-drawer>

    <edit-rate
      :value="rateVisit"
      @cancel="rateVisit = null"
      @save="updateVisit($event)"
    ></edit-rate>
  </v-card>
</template>

<script>
"use strict";

import moment from "moment";
import StarRating from "vue-star-rating";
import { mapState } from "vuex";
import { EventBus } from "@/bus";
import companyService from "@/services/CompanyService";
import contractorCompany from "@/services/ContractorCompanyService";
import roles from "@/utils/roles";

import comments from "@/components/common/comments.vue";
import datepickerComponent from "@/components/common/datepicker.vue";
import editRate from "@/components/views/rates/edit-rate.view.vue";
import BarLoader from "@/components/common/bar-loader.vue";

export default {
  name: "historyVisit",
  async mounted() {
    EventBus.$on("pendingRateSaved", this.updateVisit);
    this.getVisitList();
  },
  components: {
    StarRating,
    editRate,
    comments,
    datepickerComponent,
    BarLoader
  },
  data() {
    const resx = this.$store.state.locale.resx;
    return {
      itemsPerPage: parseInt(localStorage.getItem(this.$options.name + '_itemsPerPage')) || 50,
      search: "",
      loading: false,
      rateVisit: null,
      selectedVisit: null,
      showDetail: false,
      firstTimeLoading: true,
      headers: [
        {
          text: resx.labels.contractor,
          value: "contractorCompany.contractor.name",
          filter: this.filterName
        },
        {
          text: resx.labels.dateStart,
          value: "dateOfVisit",
          filter: this.filterDateFrom
        },
        {
          text: resx.labels.dateEnd,
          value: "endOfVisit" || "ratedAt",
          filter: this.filterDateTo
        },
        {
          text: resx.labels.visitDuration,
          value: "duration"
        },
        {
          class: "hidden-xs-only",
          text:
            this.filter != "active"
              ? resx.labels.qualification
              : resx.labels.status,
          value: this.filter != "active" ? "rate" : "state"
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.comments,
          value: "comment"
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.motive,
          value: "motive"
        },
        {
          align: "center",
          sortable: false,
          text: resx.labels.actions,
          value: "actions"
        },
        // Below are for filter only
        {
          class: "hidden",
          align: "d-none",
          value: "company",
          filter: this.filterCompany
        },
      ],
      history: [],
      filters: {
        dateFrom: null,
        dateTo: null,
        company: null,
        search: null
      },
      companies: [],
      ratedBy: null,
    };
  },
  destroyed() {
    EventBus.$off("pendingRateSaved", this.updateVisit);
  },
  computed: {
    ...mapState({
      refreshVisits: state => state.refreshes.activateRefresh.refreshed
    }),
    canRate() {
      return roles.loggedUserHasRoles(
        this.$store.state.auth.user.roles,
        this.$store.state.constants.roles.COMPANY_SUPERVISOR_ROLES
      );
    },
    count: function() {
      if (!this.$refs.dataTable || !this.$refs.dataTable.internalCurrentItems) return 0;
      return Object.keys(this.$refs.dataTable.internalCurrentItems).length;
    }
  },
  watch: {
    refreshVisits() {
      let refreshed = this.$store.state.refreshes.activateRefresh.refreshed;
      if (refreshed == true) {
        this.getVisitList();
      }
    },
    filter(value, oldValue) {
      if (value != oldValue) {
        this.pagination.page = 1;
      }
    }
  },
  methods: {
    saveItemsPerPage(val) {
      this.itemsPerPage = val;
      localStorage.setItem(this.$options.name + '_itemsPerPage', val);
    },
    async getVisitList() {
      this.loading = true;
      try {
        this.companies = await companyService.getCompanies();
        this.history = await companyService.getAllVisitsFromAllContractors(
          this.$store.state.auth.user.company._id,
          this.filter
        );
        this.$store.state.refreshes.activateRefresh.refreshed = false;
      } catch (error) {
        console.error("Error loading visit list: ", error);
      } finally {
        this.loading = false;
        this.firstTimeLoading = false;
      }
    },
    async updateVisit(visit) {
      const idx = this.history.findIndex(history => history._id == visit._id);
      await contractorCompany.updateVisit(
        visit._id,
        "rated",
        visit.hasRequestAccess
      );
      if (idx >= 0) {
        this.$set(this.history, idx, visit);
      }
      if (this.selectedVisit) {
        this.$set(this, "selectedVisit", visit);
      }
    },
    openDetail(visit) {
      this.selectedVisit = visit;
      this.showDetail = true;
    },
    closeDetail() {
      this.showDetail = false;
      this.selectedVisit = null;
    },
    duration(visit) {
      this.visitStartDate =
        visit && moment(visit.dateOfVisit).format("YYYY-MM-DD");
      if (visit && !visit.endOfVisit) {
        this.visitEndDate = moment().format("YYYY-MM-DD");
      } else if (visit) {
        this.visitEndDate =
          visit && moment(visit.endOfVisit).format("YYYY-MM-DD");
      };
      this.visitStartTime =
        visit && moment(visit.dateOfVisit).format("HH:mm");
      this.visitEndTime =
        visit && moment(visit.endOfVisit).format("HH:mm");
      const start = moment(this.visitStartDate + "T" + this.visitStartTime);
      const end = moment(this.visitEndDate + "T" + this.visitEndTime);
      const timeDiff = end.diff(start);
      let hours = parseInt(moment.duration(timeDiff).asHours());
      let minutes = moment.duration(timeDiff).asMinutes() - (hours * 60);
      if (minutes < 10) minutes = '0' + minutes;
      return hours + ':' + minutes;
    },
    formatDuration() {
      if (this.duration) {
        return moment
          .utc(moment.duration(+this.duration, "minutes").asMilliseconds())
          .format("HH:mm");
      } else {
        return null;
      }
    },
    filterName(value) {
      if (!this.filters.search) {
        return true;
      }
      return value.normalize("NFD").replaceAll(/[\u0300-\u036f]/g, "").toLowerCase().includes(this.filters.search.toLowerCase());
    },
    filterCompany(companyId) {
      if (!this.filters.company) {
        return true;
      }
      return companyId == this.filters.company;
    },
    filterDateFrom(dateFrom) {
      if (!this.filters.dateFrom || this.filters.dateFrom.trim() === "") return true;
      return (
        moment(dateFrom).isSameOrAfter(moment(this.filters.dateFrom))
      );
    },
    filterDateTo(dateTo) {
      if (!this.filters.dateTo || this.filters.dateTo.trim() === "") return true;
      return (
        moment(dateTo).isSameOrBefore(moment(this.filters.dateTo))
      );
    },
  },
  props: {
    filter: { type: String, default: "all" }
  },
};
</script>

<style lang="scss">
#visitDetail {
  .visit-motive {
    .v-list__tile {
      max-height: 96px;
    }
    .v-list__tile__title {
      white-space: normal;
      overflow: initial;
      text-overflow: initial;
      height: auto;
      max-height: 96px;
    }
  }
    .v-toolbar__title {
    padding-left: 0px;
  }

  .datetime-layout {
    max-height: 25px;
  }

  .v-list--two-line .v-list__tile {
    height: 57px;
  }
  .v-navigation-drawer__content {
    .row .col-12 {
      padding-top: 0px;
    }
    .v-list-item__content .v-list-item__title {
      text-overflow: inherit;
      white-space: normal;
    }
  }
}

#historyVisits {
  .v-toolbar__content {
    height: 50px !important;
  }

  .count-items {
    margin-top: 20px;
    min-width: 100px;
    text-align: right;
    z-index: 5;
  }

  .v-card {
    overflow-y: auto;
    height: 100%;
  }

  .v-data-table table tbody tr td:nth-child(9) {
    display: none;
  }
  .hidden {
    display: none;
  }
  
}
</style>
